import React from 'react'
import { Button, Form, Input, Select, Radio } from 'antd'

// mobx
import { useStore } from '@/store'
import { set, runInAction, toJS } from 'mobx'
import { observer } from 'mobx-react-lite'
// mobx
import { validatLength, validatLength2 } from '@/utils/check'

const VideoInput = ({ title }) => {
  const { VideoStore } = useStore()
  //获得table数据
  // 取消按钮
  const [form] = Form.useForm()

  //表单提交
  const onFinish = async (values) => {
    if (title === '添加') {
      await VideoStore.getAddButtom(values)
    } else if (title === '编辑') {
      await VideoStore.getPutInformation(values)
    }
    runInAction(() => {
      set(VideoStore, { isActive: false })
    })
    form.resetFields()
  };

  return (
    <>
      {
        title === '添加' &&
        <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          form={form}
          onFinish={onFinish}

        >
          <Form.Item label="所属系统" name='jrxtid'
            rules={[
              {
                required: true,
                message: '所属系统',
              }
            ]}>
            <Select placeholder="请选择" options={toJS(VideoStore.selectList)}>
            </Select>
          </Form.Item>
          <Form.Item label="所属企业" name='qyxxid'
            rules={[
              {
                required: true,
                message: '所属企业',
              }
            ]}>
            <Select placeholder="请选择" options={toJS(VideoStore.selectList2)}>
            </Select>
          </Form.Item>
          <Form.Item label="所属单元" name="dyglid" rules={[
            {
              required: true,
              message: '所属单元',
            }
          ]}>
            <Select placeholder="请选择" options={toJS(VideoStore.selectList3)}>
            </Select>
          </Form.Item>
          <Form.Item label="工作状态" name="spzt" rules={[
            {
              required: true,
              message: '请选择系统状态',
            }
          ]}>
            <Radio.Group>
              <Radio value={1}>启用</Radio>
              <Radio value={2}>禁用</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item label="视频编号" name="spbh" rules={[
            {
              required: true,
              message: '请输入视频编号',
            },
            {
              validator: validatLength
            }
          ]}>
            <Input placeholder="请输入视频编号" />
          </Form.Item>
          <Form.Item label="视频名称" name="spmc" rules={[
            {
              required: true,
              message: '请输入视频名称',
            },
            {
              validator: validatLength2
            }
          ]}>
            <Input placeholder="请输入视频名称" />
          </Form.Item>
          <Form.Item label="视频型号" name="spxh" rules={[
            {
              required: true,
              message: '请输入视频型号',
            },
            {
              validator: validatLength
            }
          ]}>
            <Input placeholder="请输入视频型号" />
          </Form.Item>
          <Form.Item label="生产企业" name="scqy" rules={[
            {
              required: true,
              message: '请输入生产企业',
            },
            {
              validator: validatLength2
            }
          ]}>
            <Input placeholder="请输入生产企业" />
          </Form.Item>
          <Form.Item label="视频IP" name="spip" rules={[
            {
              required: true,
              message: '请输入视频IP',
            },
            {
              validator: validatLength
            }
          ]}>
            <Input placeholder="请输入视频IP" />
          </Form.Item>
          <Form.Item label="视频URL" name="spurl" rules={[
            {
              required: true,
              message: '请输入视频URL',
            }
          ]}>
            <Input placeholder="请输入视频URL" />
          </Form.Item>
          <Form.Item label="备注信息" name="bz" rules={[
            {
              required: true,
              message: '请输入备注信息',
            }
          ]}>
            <Input.TextArea showCount maxLength={100} style={{ height: 120, resize: 'none', }} placeholder="请输入信息" />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 6 }}>
            <Button type="primary" htmlType="submit">
              立即添加
            </Button>
          </Form.Item>
        </Form>
      }
      {
        title === '编辑' &&
        <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          form={form}
          onFinish={onFinish}
          initialValues={toJS(VideoStore.valueData)}
        >
          <Form.Item label="所属系统" name='jrxtid'
            rules={[
              {
                required: true,
                message: '所属系统',
              }
            ]}>
            <Select placeholder="请选择" options={toJS(VideoStore.selectList)}>
            </Select>
          </Form.Item>
          <Form.Item label="所属企业" name='qyxxid'
            rules={[
              {
                required: true,
                message: '所属企业',
              }
            ]}>
            <Select placeholder="请选择" options={toJS(VideoStore.selectList2)}>
            </Select>
          </Form.Item>
          <Form.Item label="所属单元" name="dyglid" rules={[
            {
              required: true,
              message: '所属单元',
            }
          ]}>
            <Select placeholder="请选择" options={toJS(VideoStore.selectList3)}>
            </Select>
          </Form.Item>
          <Form.Item label="工作状态" name="spzt" rules={[
            {
              required: true,
              message: '请选择系统状态',
            }
          ]}>
            <Radio.Group>
              <Radio value={1}>启用</Radio>
              <Radio value={2}>禁用</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item label="视频编号" name="spbh" rules={[
            {
              required: true,
              message: '请输入视频编号',
            },
            {
              validator: validatLength
            }
          ]}>
            <Input placeholder="请输入视频编号" />
          </Form.Item>
          <Form.Item label="视频名称" name="spmc" rules={[
            {
              required: true,
              message: '请输入视频名称',
            },
            {
              validator: validatLength2
            }
          ]}>
            <Input placeholder="请输入视频名称" />
          </Form.Item>
          <Form.Item label="视频型号" name="spxh" rules={[
            {
              required: true,
              message: '请输入视频型号',
            },
            {
              validator: validatLength
            }
          ]}>
            <Input placeholder="请输入视频型号" />
          </Form.Item>
          <Form.Item label="生产企业" name="scqy" rules={[
            {
              required: true,
              message: '请输入生产企业',
            },
            {
              validator: validatLength2
            }
          ]}>
            <Input placeholder="请输入生产企业" />
          </Form.Item>
          <Form.Item label="视频IP" name="spip" rules={[
            {
              required: true,
              message: '请输入视频IP',
            },
            {
              validator: validatLength
            }
          ]}>
            <Input placeholder="请输入视频IP" />
          </Form.Item>
          <Form.Item label="视频URL" name="spurl" rules={[
            {
              required: true,
              message: '请输入视频URL',
            }
          ]}>
            <Input placeholder="请输入视频URL" />
          </Form.Item>
          <Form.Item label="备注信息" name="bz" rules={[
            {
              required: true,
              message: '请输入备注信息',
            }
          ]}>
            <Input.TextArea showCount maxLength={100} style={{ height: 120, resize: 'none', }} placeholder="请输入信息" />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 6 }}>
            <Button type="primary" htmlType="submit">
              修改内容
            </Button>
          </Form.Item>
        </Form>
      }
      {
        title === '查看' &&
        <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          layout="inline"
          form={form}
          onFinish={onFinish}
          initialValues={toJS(VideoStore.valueData)}
          className='check'
        >
          <iframe src={'http://player2.365kaili.net/easyplay/?m3u8=' + toJS(VideoStore.valueData.spurl)} width='100%' height="400px" className='spin'></iframe>
          <Form.Item label="所属系统" >
            {VideoStore.valueData.xtmc}
          </Form.Item>
          <Form.Item label="所属企业" >
            {VideoStore.valueData.qymc}
          </Form.Item>
          <Form.Item label="所属单元" >
            {VideoStore.valueData.dymc}
          </Form.Item>
          <Form.Item label="工作状态" >
            {VideoStore.valueData.spzt === 1 ? '启用' : '禁用'}
          </Form.Item>
          <Form.Item label="视频编号" >
            {VideoStore.valueData.spbh}
          </Form.Item>
          <Form.Item label="视频名称" >
            {VideoStore.valueData.spmc}
          </Form.Item>
          <Form.Item label="视频型号" >
            {VideoStore.valueData.spxh}
          </Form.Item>
          <Form.Item label="生产企业" >
            {VideoStore.valueData.scqy}
          </Form.Item>
          <Form.Item label="视频IP" >
            {VideoStore.valueData.spip}
          </Form.Item>
          <Form.Item label="视频url" >
            {VideoStore.valueData.spurl}
          </Form.Item>
          <Form.Item label="备注信息" >
            {VideoStore.valueData.bz}
          </Form.Item>
        </Form>
      }
    </>
  )
}

export default observer(VideoInput)